import React from "react";
import PaginatedList from "../../../Pagination/PaginationList";
import { Link } from "react-router-dom";

const Listing = () => {
  const list = [
    1, 2, 3, 4, 5, 6
  ];
  return (
    <>
      <div className="listing-container">
        {list.map((post) => {
          return (
            <Link to="/blogPage">
              <div className="post-item">
                <div className="post-image-item"></div>
                <div className="post-cat-time">
                  <span>Travel</span>
                  <span>13 March 2023</span>
                </div>
                <div className="post-details-text">
                  <span>Train Or Bus Journey?Which one suits?</span>
                  <span>
                    The choice between a train or bus journey depends on various
                    factors such as the distance of the journey, the time
                    available, the cost, and person
                  </span>
                  <a href="#">
                    <span className="read-more">Read More...</span>
                  </a>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
      <PaginatedList></PaginatedList>
    </>
  );
};

export default Listing;
